const FormCheck = ({
    label = "Label",
    labelNode,
    name = "",
    onChange,
    checked = false,
    onLabelClick,
}) => {
    return (
        <div className="form-check">
            <input className="form-check-input" type="checkbox" value="" id={name} onChange={onChange} checked={checked} />
            {labelNode ? (
                <label className="form-check-label" htmlFor={name} onClick={onLabelClick}>
                    {labelNode}
                </label>
            ) : (
                <label className="form-check-label" htmlFor={name} onClick={onLabelClick} dangerouslySetInnerHTML={{ __html: label }} />
            )}
        </div>
    );
};
export default FormCheck;